<template>
  <div id="Software">
    <div class="flex">
      <img
        src="@/assets/images/pic200-22.svg"
        style="width: 100%; max-width: 524px; height: auto"
        alt=""
      />
    </div>
    <div class="text">
      该方案能够形成一套集预防、随访、健康管理为一体的动态全周期医疗健康服务。对患者身体指标通过可穿戴设备实现实时的监测，以循环式服务对慢性病患者进行管理，做到预防、治疗、控制、康复相结合，培育医疗健康产业新经济、新模式、新功能，实现慢性病防治工作战略前移。满足慢病患者的健康需求，促进居民健康发展，提高健康管理整体服务能力。
    </div>
  </div>
</template>
<script>
export default {
  name: "Software",
  data() {
    return {};
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.text {
  line-height: 24px;
  font-weight: 500;
  color: #666;
  margin-top: 40px;
  text-indent: 28px
}
</style>




// WEBPACK FOOTER //
// src/view/Solution7.vue